exports.linkResolver = ({ uid, type }) => {
  if (type === 'blog_post') return `/blog/${uid}`;
  if (uid) return `/${uid}`;
  return '/';
};
